import toast from "react-hot-toast";
import classes from "./GenerateKey.module.css";
import ModalWrapper from "../../modalWrapper/ModalWrapper";
import { ActionBtn } from "../../buttons/actionBtn/ActionBtn";
import { useEffect } from "react";
import { InputElement } from "../../inputElement/InputElement";
import { LoadingSpinner } from "../../loadingSpinner/LoadingSpinner";
import { useTranslations } from "../../../helperFunctions/customHooks/useTranslations";
import { useStatusEffect } from "../../../helperFunctions/customHooks/useStatusEffect";
import { validateRequiredFields } from "../../../helperFunctions/validateRequiredFields";
import { useDispatch, useSelector } from "react-redux";
import {
  resetApiKeyForm,
  setApiKeyForm,
} from "../../../redux/forms/apiKeyForm";
import {
  generateApiKey,
  resetGenerateApiKeyState,
} from "../../../redux/integrations/generateApiKey";
import {
  setIsApiKeyModalShown,
  setIsGenerateApiShown,
} from "../../../redux/globalFunctions/globalFnSlice";

export function GenerateKey() {
  const dispatch = useDispatch();
  const { t } = useTranslations();
  const text = t.generateKeyModal;
  const validationText = t.formValidations;

  const { status, error } = useSelector((state) => state.generateApiKey);
  const formData = useSelector((state) => state.forms.apiKeyForm);

  function handleCloseModal() {
    dispatch(setIsGenerateApiShown(false));
  }

  function handleGenerateClick(e) {
    e.preventDefault();

    const requiredFields = ["name", "purpose"];

    const errors = validateRequiredFields(
      formData,
      requiredFields,
      validationText
    );

    if (errors.length > 0) {
      toast.dismiss();
      setTimeout(() => {
        errors.forEach((err) =>
          toast.error(err, {
            duration: 2000,
          })
        );
      }, 100);
      return;
    }

    dispatch(
      generateApiKey({ name: formData.name, description: formData.purpose })
    );
  }

  function handleOnChange(e) {
    const { name, value } = e.target;
    dispatch(setApiKeyForm({ [name]: value }));
  }

  useEffect(() => {
    if (status === "success") {
      dispatch(setIsGenerateApiShown(false));
      dispatch(setIsApiKeyModalShown(true));
      dispatch(resetApiKeyForm());
    }
  }, [status]);

  useStatusEffect({
    status: status,
    errorMessage: text.failedGenerating + " " + error,
    resetStatus: resetGenerateApiKeyState,
    onError: setIsGenerateApiShown,
  });

  return (
    <ModalWrapper title={text.title} onClick={handleCloseModal}>
      <form className={classes.form}>
        <InputElement
          labelText={text.name}
          id={"name"}
          name={"name"}
          value={formData.name || ""}
          onChange={handleOnChange}
        />
        <InputElement
          labelText={text.purpose}
          id={"purpose"}
          name={"purpose"}
          value={formData.purpose || ""}
          onChange={handleOnChange}
        />
        <ActionBtn
          width={"100%"}
          height={"42px"}
          text={status === "loading" ? <LoadingSpinner /> : text.generate}
          onClick={handleGenerateClick}
          disabled={status === "loading"}
        />
      </form>
    </ModalWrapper>
  );
}
